// extracted by mini-css-extract-plugin
var _1 = "MGVOD";
var _2 = "QdAk_";
var _3 = "hdfbL";
export { _1 as "divider", _2 as "logoDimensions", _3 as "navMenuLayout" }
